export default {
  login: {
    title: 'Fabrikkan',
    tableNumber: 'Veldu staðsetningu og númer á borðinu sem þú ert að þjóna',
    pin: 'Sláðu inn pinnið til að byrja',
  },
  language: {
    is: 'ÍSL',
    en: 'ENG',
  },
  layout: {
    continue: 'Áfram',
    table: 'Borð',
    number: 'nr.',
    waiter: 'Þjónn',
    back: 'Til baka',
    menu: 'Matseðill',
    logout: 'Fara aftur í innskráningu',
    summary: {
      home: {
        dialog: {
          title: 'Heim',
          message: 'Aftur í matseðilinn?',
          ok: 'Já',
          cancel: 'Nei',
        },
      },
    },
    dialog: {
      title: 'Hjálp',
      message: 'Kalla á þjón?',
    },
  },
  customer: {
    or: 'Eða',
    menu: {
      title: 'Má bjóða þér að',
      order: 'Panta beint',
      menu: 'af matseðli',
      button: 'Skoða matseðil',
    },
    waiter: {
      subTitle: 'Fá að',
      title: 'Tala við þjón',
      button: 'Bíða eftir þjóni',
      dialog: {
        title: 'Staðfesting',
        message: 'Viltu panta hjá þjón?',
        ok: 'Já',
        cancel: 'Nei',
      },
    },
  },
  waiter: {
    title: 'Þjónninn kemur eftir augnablik',
    dialog: {
      title: 'Staðfesting',
      message: 'Viltu kalla á þjón?',
    },
  },
  navigation: {
    back: 'Til baka',
  },
  menu: {
    title: 'Matseðill',
  },
  category: {
    dialog: {
      title: 'Áfengi er aðeins fyrir 20+',
      message: 'Vinsamlegast staðfestu að þú hefur náð þeim aldri. Við áskiljum okkur rétt til þess að spurja um skilríki.',
      ok: 'Já',
      cancel: 'Nei',
    },
  },
  product: {
    includeEverything: 'Viltu allt sem fylgir?',
    change: 'Stækkað og breytt',
    fries: 'Frönskurnar eru betri með hliðarsósu',
    bread: 'Viltu breyta brauðinu?',
    added: 'bættist við pöntun',
    dialog: {
      title: 'Athugið',
      message: 'Er allt rétt?',
    },
  },
  footer: {
    addProduct: 'Bæta í pöntun',
    updateProduct: 'Uppfæra í pöntun',
    confirmOrder: 'Staðfesta pöntun',
    viewOrder: 'Skoða',
  },
  order: {
    title: 'Þín pöntun',
    editProduct: 'Breyta',
    removeProduct: 'Eyða',
    total: 'Samtals',
    dialogs: {
      sendOrder: {
        title: 'Staðfesta pöntun',
        message: 'Er allt rétt?',
        ok: 'Já',
        cancel: 'Nei',
      },
      removeProduct: {
        title: 'Eyða vöru úr körfu',
        message: 'Ertu viss um að þú viljir eyða "{product}" úr pöntuninni?',
        ok: 'Já',
        cancel: 'Nei',
      },
    },
  },
  orderSummary: {
    title: 'Takk fyrir pöntunina',
    order: 'Þín pöntun',
    arriving: 'Maturinn kemur innan skamms!',
    orderPlaced: 'Pantað kl',
  },
  notify: {
    addedToOrder: 'Bætt í pöntun',
    updatedInOrder: 'Uppfært í pöntun',
    waiterInOrder: 'Þjónn kemur eftir augnablik',
  },
  api: {
    error: {
      dialog: {
        ok: 'Loka',
      },
      pilotErrorCouldNotCreateOrder: {
        title: 'Gat ekki vistað pöntun',
        message: '{error}',
      },
      pilotErrorOrderNotSaved: {
        title: 'Gat ekki vistað pöntun',
        message: '{error}',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorNoData: {
        title: 'Gögn vantar',
        message: 'Pöntun var ekki vistuð. Gögn voru ekki rétt formuð: {error}',
      },
      pilotErrorPaymentProcessError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Staðfestingarkóði rangur',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorCouponExpired: {
        title: 'Afsláttarkóði útrunninn',
        message: 'Kóðinn sem þú gafst upp er ekki virkur.',
      },
      pilotErrorCouponNotFound: {
        title: 'Afsláttarkóði finnst ekki',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Kortanúmer ógilt',
        message: 'Athugaðu hvort þú hafir gefið upp rétt númer.',
      },
      pilotErrorExpiredCard: {
        title: 'Gildistími korts er útrunninn',
        message: 'Prófaðu annað kort eða annan greiðslumáta.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Villa í kortanúmeri',
        message: 'Kortanúmer verður að vera 11 til 19 tölustafir',
      },
      pilotErrorOrderNotValid: {
        title: 'Engin pöntun fannst',
        message: 'Það getur gerst ef vöruúrval breytist.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'Við getum ekki afgreitt "{product}"',
        message: 'Þú verður að velja annan afhendingarmáta.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Lágmarksupphæð ekki náð',
        message: 'Til að geta valið þennan afhendingarmáta þarf að panta meira.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er ekki í boði fyrir þennan afhendingarmöguleika.',
      },
      pilotErrorInvalidPinNumber: {
        title: 'Rangt pin númer',
        message: 'Reyndu aftur.',
      },
      couponNeedsDesktop: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður á vefnum.',
      },
      couponNeedsCordova: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður í appi.',
      },
      notAllowed: {
        title: 'Aðgerð ekki framkvæmd',
        message: 'Notandi hefur ekki tilskilin leyfi.',
      },
      ECONNABORTED: {
        title: 'Samskipti runnu út á tíma',
        message: 'Keyrsla tók óeðlilega langan tíma.',
      },
    },
  },
  serviceWorker: {
    event: {
      updated: {
        title: 'Ný útgáfa af vefnum er í boði',
        message: 'Þú þarft aðeins að endurhlaða síðuna til að uppfæra.',
        ok: 'Endurhlaða síðuna',
        cancel: 'Ekki núna',
      },
    },
  },
};
